const SavingsFollowupReportActionTypes = {
	/** ***************** GET SAVINGS FOLLOWUP REPORT START *********************** */
	GET_SAVINGS_FOLLOWUP_REPORT_START: 'get_savings_followup_report_start',
	GET_SAVINGS_FOLLOWUP_REPORT_SUCCESS: 'get_savings_followup_report_success',
	GET_SAVINGS_FOLLOWUP_REPORT_FAILURE: 'get_savings_followup_report_failure',
	GET_SAVINGS_FOLLOWUP_REPORT_RESPONSE_RESET: 'get_savings_followup_report_response_reset',
	GET_SAVINGS_FOLLOWUP_REPORT_RESPONSE_CHANGED: 'get_savings_followup_report_response_changed',
	/** ***************** GET SAVINGS FOLLOWUP REPORT END *********************** */
};

export default SavingsFollowupReportActionTypes;
